import * as types from './actionTypes';
import { loadActiveCases } from '../store/browserStorage';
import { unloadAllCases } from './caseActions';

export function setAuthToken(accessToken) {
  return { type: types.SET_AUTH_TOKEN, accessToken };
}

export function loginSuccess(user) {
  let activeCases = loadActiveCases();
  if (activeCases.length > 0) {
    unloadAllCases(activeCases);
  }
  return { type: types.AUTH_LOGIN_SUCCESS, user };
}

export function loginFailure(error) {
  return { type: types.AUTH_LOGIN_FAILURE, error };
}

export function logoutUser() {
  let activeCases = loadActiveCases();
  if (activeCases.length > 0) {
    unloadAllCases(activeCases);
  }
  return { type: types.LOGOUT_USER };
}

export function updateTokenExpirationTime(tokenExpiry) {
  return { type: types.UPDATE_TOKEN_EXPIRY_TIME, tokenExpiry };
}

export function newLogin() {
  return { type: types.NEW_LOGIN };
}
